import React, { useState, useEffect } from 'react';
import { getDocs, collection } from '@firebase/firestore';
import { db } from './firebase-config';
import './PlaylistsPage.css';

const PlaylistsPage = () => {
  const [playlists, setPlaylists] = useState([]);

  // Fetch playlists from Firestore on component mount
  useEffect(() => {
    const loadPlaylists = async () => {
      const querySnapshot = await getDocs(collection(db, 'well-being-playlists'));
      const loadedPlaylists = querySnapshot.docs.map((doc) => doc.data());
      setPlaylists(loadedPlaylists);
    };
    loadPlaylists();
  }, []);

  const getEmbedCode = (playlist) => {
    if (playlist.playlist_type === 'Spotify') {
      return (
        <iframe
          style={{ borderRadius: '12px' }}
          src={`https://open.spotify.com/embed/${playlist.asset_type}/${playlist.embed_code}`}
          width="100%"
          height="500"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        ></iframe>
      );
    } else if (playlist.playlist_type === 'Apple') {
      return (
        <iframe
          allow="autoplay *; encrypted-media *; fullscreen *"
          frameBorder="0"
          height="500"
          style={{ width: '100%', maxWidth: '660px', overflow: 'hidden', borderRadius: '12px' }}
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
          src={`https://embed.music.apple.com/us/playlist/${playlist.embed_code}`}
        ></iframe>
      );
    }
    return null; // Add other embed codes as needed
  };

  return (
    <div className="playlist-page">
      <div className="playlist-intro">
        <h2>Music & Guided Meditations for Well-being</h2>
        <p>Music has a profound impact on well-being, from relieving stress to enhancing mood. Explore FireUp's curated playlists designed to promote relaxation, focus, and mindfulness.</p>
      </div>

      <div className="playlist-gallery">
        {playlists.map((playlist, index) => (
            <div className="playlist-card" key={index}>
              <h3>{playlist.summary}</h3>
              <div dangerouslySetInnerHTML={{ __html: playlist.description }} />
              {getEmbedCode(playlist)}
            </div>
        ))}
      </div>
    </div>
  );
};

export default PlaylistsPage;
